import React from 'react';
// import { EditIcon } from '../../../../../assets/icons';

const BasicInfo = ({ userDetail, onEditAbout }) => {
    return (
        <div className="overview-tab">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h5 className="overview-details-card-title fw-bold mb-0" style={{ fontSize: '18px' }}>About</h5>
            </div>
            <p className="overview-details-bio mb-4  p-2 bg-light rounded-2" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                {userDetail?.profile?.about || "No bio added yet."}
            </p>
            <div className="overview-details-list flex-grow-1">
                <div className="overview-details-row">
                    <span className="overview-details-label">Profession</span>
                    <span className="overview-details-value text-dark">{userDetail?.profile?.profession?.name || "-"}</span>
                </div>
                <div className="overview-details-row">
                    <span className="overview-details-label">Headline</span>
                    <span className="overview-details-value fw-semibold text-dark">{userDetail?.profile?.headline || "-"}</span>
                </div>
                <div className="overview-details-row">
                    <span className="overview-details-label">Website</span>
                    <span className="overview-details-value">
                        {userDetail?.profile?.website ? (
                            <a href={userDetail.profile.website} target="_blank" rel="noopener noreferrer" className="overview-details-link">
                                {userDetail.profile.website}
                            </a>
                        ) : "-"}
                    </span>
                </div>
                <div className="overview-details-row">
                    <span className="overview-details-label">Whatsapp</span>
                    <span className="overview-details-value text-dark">{userDetail?.profile?.whatsapp_number || "-"}</span>
                </div>
                <div className="overview-details-row">
                    <span className="overview-details-label">Address</span>
                    <span className="overview-details-value text-dark">{userDetail?.profile?.address || "-"}</span>
                </div>
                <div className="overview-details-row">
                    <span className="overview-details-label">City</span>
                    <span className="overview-details-value text-dark">{userDetail?.profile?.city?.name || "-"}</span>
                </div>
                <div className="overview-details-row">
                    <span className="overview-details-label">State</span>
                    <span className="overview-details-value text-dark">{userDetail?.profile?.city?.state?.name || "-"}</span>
                </div>
                <div className="overview-details-row align-items-start">
                    <span className="overview-details-label pt-1">Categories</span>
                    <div className="overview-details-value d-flex flex-wrap gap-1">
                        {userDetail?.categories?.length > 0 ? (
                            userDetail.categories.map((cat, i) => (
                                <span key={i} className="category-badge">{cat.name || cat}</span>
                            ))
                        ) : (
                            <span className="text-muted">-</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicInfo;
